// src/App.js
// Clean entry point — was 65 lines, now 20 lines.
// All routes moved to src/routes/ folder (GEMS pattern).
// Nothing else changed — same functionality, same URLs.

import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./asset/css/pageHeading.css";
import "./asset/css/pageSubheading.css";
import { BrowserRouter as Router } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AppRoutes from "./routes/index";

function App() {
  return (
    <Router>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
        draggable
      />
      <div className="min-h-screen flex flex-col">
        <AppRoutes />
      </div>
    </Router>
  );
}

export default App;
